import { useCacheLocal } from "@/hooks/useCacheLocal";
import { createContext, ReactNode, useContext, useState } from "react";

type TSettingFilterCache = {
  page?: number | null;
  tab?: string | null;
};

type SettingFilterCacheContextType = {
  settingFilterCache: TSettingFilterCache;
  setSettingFilterCache: (newFilter: TSettingFilterCache) => void;
};

const SettingFilterCacheContext = createContext<SettingFilterCacheContextType | undefined>(undefined);

export const SettingFilterCacheProvider = ({ children }: { children: ReactNode }) => {
  const { getJSON, setJSON } = useCacheLocal("setting-filter");

  const [settingFilterCache, setContactFilter] = useState<TSettingFilterCache>({
    ...getJSON(),
  });

  const setSettingFilterCache = (newFilter: TSettingFilterCache) => {
    setJSON(newFilter);
    setContactFilter(newFilter);
  };

  return <SettingFilterCacheContext.Provider value={{ settingFilterCache, setSettingFilterCache }}>{children}</SettingFilterCacheContext.Provider>;
};

export const useSettingFilterCache = (): SettingFilterCacheContextType => {
  const context = useContext(SettingFilterCacheContext);
  if (!context) {
    throw new Error("useSettingFilterCache must be used within SettingFilterCacheProvider");
  }
  return context;
};
